'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconSquareCheck, iconSquareCheckTag } from '@ni/nimble-components/dist/esm/icons/square-check';
import { wrap } from '../../utilities/react-wrapper';

export type { IconSquareCheck };
export { iconSquareCheckTag };
export const NimbleIconSquareCheck = wrap(IconSquareCheck);